<template>
  <layout-card-wrap hasHeaderSlot
                    style="margin-top: 15px"
                    v-loading="loading">
    <template slot="title">账号信息</template>
    <div slot="form">
      <el-button type="primary"
                 @click="additem"
                 :loading="loading">新增</el-button>
      <el-button type="primary"
                 style="margin-left: 10px"
                 @click="getstaffs"
                 :loading="loading">刷新</el-button>
    </div>
    <el-table border
              stripe
              :data="list">
      <el-table-column label="账号"
                       prop="account">
      </el-table-column>
      <el-table-column label="员工/合作商"
                       prop="staffName">
      </el-table-column>
      <el-table-column label="手机号码"
                       prop="mobile">
      </el-table-column>
      <el-table-column label="操作"
                       width="110">
        <template slot-scope="{row}">
          <el-button type="text"
                     v-if="row.isAdmin === 0"
                     @click="edititem(row)">编辑</el-button>
          <el-dropdown v-if="row.isAdmin === 0">
            <el-button type="text"
                       style="margin-left: 10px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="setstaffvendors(row)">监管企业范围</el-dropdown-item>
              <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="resetpassword(row)">重置密码</el-dropdown-item>
               <el-dropdown-item @click.native="getpromotionlink(row)">生成推广链接</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <edit-supervise-staff-modal :callback="getstaffs"
                                ref="staff" />
    <vendor-scope-set-modal ref="scope" />
  </layout-card-wrap>
</template>

<script>
import { mapState } from 'vuex'
import EditSuperviseStaffModal from './edit-supervise-staff-modal.vue'
import VendorScopeSetModal from './vendor-scope-set-modal.vue'
import Supervise from '@/service/supervise'
export default {
  name: 'supervise-staff-table',
  components: { EditSuperviseStaffModal, VendorScopeSetModal },
  data () {
    return {
      loading: false,
      list: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    getpromotionlink (row) {
      this.loading = true
      Supervise.getpromotionlink({ staffId: row.staffId }).then(res => {
        this.loading = false
        const { result, message, data } = res.data
        if (result === 0) {
          const [a, b] = data.split('?')
          this.$copyText(`${a}/#/login?${b}`).then(() => {
            this.$message.success('复制推广链接成功')
          }, () => {
            this.$message.error('复制失败，请重试')
          })
        } else {
          this.$message.error(message)
        }
      }).catch(err => {
        this.loading = false
        console.log(err)
        this.$message.error('生成推广链接失败')
      })
    },
    resetpassword (row) {
      this.$confirm('此操作将重置密码, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('common/resetpassword', {
            payload: { account: row.account },
            success: res => {
              this.getstaffs()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    setstaffvendors (row) {
      this.$refs.scope.fetch(row)
    },
    additem () {
      this.$refs.staff.init({})
    },
    deleteitem (row) {
      this.$confirm('此操作将永久删除该账号, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('staff/deletestaff', {
            payload: { staffId: row.staffId },
            success: (res) => {
              this.loading = false
              this.getstaffs()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    edititem (row) {
      const { staffId, account, staffName, mobile, functions } = row
      this.$refs.staff.init({ staffId, account, staffName, mobile, functions })
    },
    getstaffs () {
      this.loading = true
      this.$store.dispatch(`staff/getstaffs`, {
        payload: { pageNum: 1, pageSize: 1000 },
        success: (res) => {
          this.loading = false
          this.list = res.data.records.map(i => {
            i.functions = i.functions.map(s => s.funcId)
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  mounted () {
    this.getstaffs()
  }
}
</script>
